//import { red } from "@material-ui/core/colors";
import { createTheme } from "@material-ui/core/styles";

// https://material-ui.com/customization/default-theme/

export const dark = createTheme({
  typography: {
    fontFamily: ["Raleway", "Roboto", "Helvetica", "Arial", "sans-serif"],
    //fontSize: ".9em"
    fontSize: 13.5,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500
  },
  palette: {
    type: "dark",
    primary: {
      //main: "#303f9f"
      main: "#90caf9"
    },
    secondary: {
      //main: "#c51162"
      main: "#f48fb1"
    },
    background: {
      paper: "#333333",
      default: "#212121"
    }
  }
});

// A custom theme for this app
// const theme = createMuiTheme({
//   palette: {
//     primary: {
//       main: "#556cd6"
//     },
//     secondary: {
//       main: "#19857b"
//     },
//     error: {
//       main: red.A400
//     },
//     background: {
//       default: "#fff"
//     }
//   }
// });

// export default theme;

// export const darkThemeReference = createMuiTheme({
//   palette: {
//     primary: {
//       //main: "#303f9f"
//       main: "#90caf9"
//     },
//     secondary: {
//       //main: "#c51162"
//       main: "#f48fb1"
//     },
//     error: {
//       main: "#d32f2f"
//     },
//     disabled: {
//       main: "#999999"
//     },
//     background: {
//       paper: "#424242",
//       default: "#303030"
//     },
//     text: {
//       primary: "#fff",
//       secondary: "rgba(255, 255, 255, 0.7)",
//       disabled: "rgba(255, 255, 255, 0.5)",
//       hint: "rgba(255, 255, 255, 0.5)",
//       icon: "rgba(255, 255, 255, 0.5)"
//     },
//     divider: "rgba(255, 255, 255, 0.12)",
//     action: {
//       active: "#000",
//       hover: "rgba(255, 255, 255, 0.1)",
//       hoverOpacity: 0.1,
//       selected: "rgba(255, 255, 255, 0.2)",
//       disabled: "rgba(255, 255, 255, 0.3)",
//       disabledBackground: "rgba(255, 255, 255, 0.12)"
//     }
//   }
// });
